
/**
 * Distance mappings for chipping tests
 */

export const getChippingDistances = (testId: string): Record<string, string> => {
  // Determine the level from the URL path
  const pathname = window.location.pathname;
  const isLevel1 = pathname.includes('level1');
  const isLevel2 = pathname.includes('level2');
  
  console.log("getChippingDistances - pathname:", pathname);
  console.log("getChippingDistances - isLevel1:", isLevel1);
  console.log("getChippingDistances - isLevel2:", isLevel2);
  console.log("getChippingDistances - testId:", testId);
  
  // Level 1 chipping tests
  if (isLevel1) {
    // Chipping tests with lifted ball - Level 1
    if (testId === "chipping-plat") {
      return {
        "G": "20m",
        "H": "30m",
        "I": "40m"
      };
    }

    if (testId === "chipping-pente-droit") {
      return {
        "G1": "20m",
        "H1": "30m",
        "I1": "40m"
      };
    }
    
    // Chipping tests with rolled ball - Level 1
    if (testId === "chipping-roulee-plat") {
      return {
        "G2": "10m",
        "H2": "20m",
        "I2": "30m"
      };
    }
    
    return {};
  }
  
  // Level 2 chipping tests
  if (isLevel2) {
    // Chipping tests with lifted ball - Level 2
    if (testId === "chipping-plat") {
      return {
        "D": "15m",
        "E": "20m",
        "F": "25m"
      };
    }

    if (testId === "chipping-pente-droit") {
      return {
        "D1": "15m",
        "E1": "20m",
        "F1": "25m"
      };
    }
    
    if (testId === "chipping-pente-gauche") {
      return {
        "D2": "15m",
        "E2": "20m",
        "F2": "25m"
      };
    }

    // Chipping tests with rolled ball - Level 2
    if (testId === "chipping-roulee-plat") {
      return {
        "D3": "5m",
        "E3": "10m",
        "F3": "15m"
      };
    }
    
    return {};
  }
  
  // Level 3 chipping tests (default)
  // Chipping tests with lifted ball
  if (testId === "chipping-plat") {
    return {
      "TerPlatA": "7m",
      "TerPlatB": "10m",
      "TerPlatC": "20m"
    };
  }

  if (testId === "chipping-pente-droit") {
    return {
      "PenteDroitA1": "7m",
      "PenteDroitB1": "10m",
      "PenteDroitC1": "20m"
    };
  }
  
  if (testId === "chipping-pente-gauche") {
    return {
      "PenteGaucheA2": "7m",
      "PenteGaucheB2": "10m",
      "PenteGaucheC2": "20m"
    };
  }

  // Chipping tests with rolled ball
  if (testId === "chipping-roulee-plat") {
    return {
      "ChipRoulA": "3m",
      "ChipRoulB": "7m",
      "ChipRoulC": "10m",
      "ChipRoulD": "20m"
    };
  }
  
  if (testId === "chipping-roulee-pente") {
    return {
      "ChipRoulPenteA1": "3m",
      "ChipRoulPenteB1": "7m",
      "ChipRoulPenteC1": "10m",
      "ChipRoulPenteD1": "20m"
    };
  }
  
  if (testId === "chipping-roulee-pente-gauche") {
    return {
      "ChipRoulPenteA5": "3m",
      "ChipRoulPenteB5": "7m",
      "ChipRoulPenteC5": "10m",
      "ChipRoulPenteD5": "20m"
    };
  }

  return {};
};
